module.exports = __webpack_public_path__ + "static/nach-673ee9c9ac4b9bd4b36f604ba8e0adaf.jpg";